import { render } from "./Insbtn.vue?vue&type=template&id=261f809e&scoped=true"
import script from "./Insbtn.vue?vue&type=script&lang=js"
export * from "./Insbtn.vue?vue&type=script&lang=js"

import "./Insbtn.vue?vue&type=style&index=0&id=261f809e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-261f809e"]])

export default __exports__